/* eslint-disable react/jsx-props-no-spreading */
import React, { forwardRef, useEffect } from 'react';
import classNames from 'classnames';
import inputMask from '@uswds/uswds/packages/usa-input-mask/src';
import Input, { InputProps } from '../Input';

export type MaskingType = 'ssn' | 'phone' | 'zip';

interface MaskedInputPreDefined {
  dataCharset?: never;
  inputMode?: never;
  mask: MaskingType;
  pattern?: never;
  placeholder?: never;
}
interface MaskedInputCustom {
  dataCharset?: string;
  inputMode: 'numeric' | 'text';
  mask?: never;
  pattern: string;
  placeholder: string;
}
export type MaskedInputProps = (MaskedInputPreDefined | MaskedInputCustom) & InputProps;

type MaskProps = {
  placeholder?: string;
  pattern?: string;
  inputMode?: InputProps['inputMode'];
  'data-charset'?: string;
};
const ssnMask: MaskProps = {
  placeholder: '___ __ ____',
  pattern: '^(?!(000|666|9))d{3} (?!00)d{2} (?!0000)d{4}$',
  inputMode: 'numeric',
};

const phoneMask: MaskProps = {
  placeholder: '___-___-____',
  pattern: 'd{3}-d{3}-d{4}',
  inputMode: 'numeric',
};

const zipMask: MaskProps = {
  placeholder: '_____-____',
  pattern: '^[0-9]{5}(?:-[0-9]{4})?$',
  inputMode: 'numeric',
};

let maskProps: MaskProps = {
  placeholder: undefined,
  pattern: undefined,
  inputMode: undefined,
  'data-charset': undefined,
};

const MaskedInput = forwardRef<HTMLInputElement, MaskedInputProps>(
  ({ className, dataCharset, inputMode, mask, placeholder, pattern, ...rest }: MaskedInputProps, ref): JSX.Element => {
    useEffect(() => {
      inputMask.on();
    }, []);

    switch (mask) {
      case 'phone':
        maskProps = { ...maskProps, ...phoneMask };
        break;
      case 'ssn':
        maskProps = { ...maskProps, ...ssnMask };
        break;
      case 'zip':
        maskProps = { ...maskProps, ...zipMask };
        break;
      default:
        maskProps = { ...maskProps, placeholder, pattern, inputMode, 'data-charset': dataCharset };
        break;
    }

    return (
      <>
        <Input {...rest} {...maskProps} ref={ref} className={classNames('usa-masked', className)} />
      </>
    );
  },
);

export default MaskedInput;
